$(document).foundation();

Date.prototype.addHours = function(h) {
    this.setTime(this.getTime() + (h*60*60*1000));
    return this;
}

Date.prototype.minHours = function(h) {
    this.setHours(this.getHours() - h);
    return this;
}

let formatTime = function(time) {
    let minutes = parseInt(time.getMinutes());
    if(minutes < 10) {
        minutes = '0' + minutes;
    }

    let hour = time.getHours();
    if(formatTimeAsInt(hour + ':' + minutes) > 1700) {
        hour = 17;
        minutes = '00';
    }

    time = hour + ':' + minutes;
    return time;
}

let formatTimeAsInt = function(time) {
    time = parseInt(time.replace(':', ''));
    return time;
}

let calculateTill = function(date) {
    let time = new Date('01-01-2020 ' + date.time);
    let from = formatTimeAsInt(date.time);

    let addHours = 0;
    let breaksAdded = [];

    let startHour = 0;

    if(formatTimeAsInt(date.time) >= 800) {
        startHour = 0.5;
    }

    for(let i = startHour; i < parseFloat(date.hour) + startHour; i += 0.5) {
        addHours += 0.5;

        time = time.addHours(0.5);

        let timeAsint = formatTimeAsInt(formatTime(time));

        if(timeAsint > 915 && from <= 900 && breaksAdded.indexOf(915) === -1) {
            console.log(from)
            breaksAdded.push(915);
            time = time.addHours(0.25);
        }

        if(timeAsint > 1107 && from < 1100 && breaksAdded.indexOf(1107) === -1) {
            breaksAdded.push(1107);
            time = time.addHours(0.125);
        }

        if(timeAsint > 1300 && from <= 1230 && breaksAdded.indexOf(1300) === -1) {
            breaksAdded.push(1300);
            time = time.addHours(0.5);
        }

        if(timeAsint > 1507 && from <= 1500 && breaksAdded.indexOf(1507) === -1) {
            breaksAdded.push(1507);
            time = time.addHours(0.125);
        }
    }

    return formatTime(time);
};

let downloadElementAsPng = function(name, target) {
    html2canvas(document.querySelector(target), {
        windowWidth: 1200,
    }).then(function(canvas) {
        download(name + '.png', canvas.toDataURL());
    });
    return false;
};

// must be called in a click handler or some other user action
let download = function(filename, dataUrl) {
    let element = document.createElement('a');

    let dataBlob = dataURLtoBlob(dataUrl);
    element.setAttribute('href', URL.createObjectURL(dataBlob));
    element.setAttribute('download', filename);

    element.style.display = 'none';
    document.body.appendChild(element);

    element.click();

    let clickHandler;
    element.addEventListener('click', clickHandler=function() {
        // ..and to wait a frame
        requestAnimationFrame(function() {
            URL.revokeObjectURL(element.href);
        });

        element.removeAttribute('href');
        element.removeEventListener('click', clickHandler);
    });

    document.body.removeChild(element)
};


let dataURLtoBlob = function(dataurl) {
    let parts = dataurl.split(','), mime = parts[0].match(/:(.*?);/)[1];
    if(parts[0].indexOf('base64') !== -1) {
        let bstr = atob(parts[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new Blob([u8arr], {type:mime});
    } else {
        let raw = decodeURIComponent(parts[1]);
        return new Blob([raw], {type: mime});
    }
};

$(function () {

    $('.print').click(function () {
        let name = $(this).data('name');
        let target = $(this).data('target');
        downloadElementAsPng(name, target);
        return false;
    });

    $('.fancybox').fancybox();

    if ($(window).width() < 768) {
        $(".project__gallery a").slice(0, 2).show();

        $(".project__image__btn").on('click', function (e) {
            e.preventDefault();
            $(".project__gallery a:hidden").slice(0, 2).slideDown(20);
            if ($(".project__gallery a:hidden").length == 0) {
                $(".project__image__btn").fadeOut(300);
            }
            $('html,body').animate({
                scrollTop: $(this).offset().top-50
            }, 700);
        });

    }else{
        $(".project__gallery a").slice(0, 3).show();

        $(".project__image__btn").on('click', function (e) {
            e.preventDefault();
            $(".project__gallery a:hidden").slice(0, 3).slideDown(20);
            if ($(".project__gallery a:hidden").length == 0) {
                $(".project__image__btn").fadeOut(300);
            }
            $('html,body').animate({
                scrollTop: $(this).offset().top-200
            }, 700);
        });
    }

    $('.menu__overlay__toggle').click(function(){
        $('.menu__overlay').fadeToggle();
        $('.menu__overlay__toggle').toggleClass('btn__menu--close');
        $('body').toggleClass('menu__open');
    });


    $('.slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.slider-nav'
    });
    $('.slider-nav').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for',
        dots: false,
        arrows: false,
        centerMode: false,
        focusOnSelect: true,
        responsive: [
            {
            breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
        ]
    });

    $('.project__overview-theme2-slider-for').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        fade: true,
        asNavFor: '.project__overview-theme2-slider-nav'
    });
    $('.project__overview-theme2-slider-nav').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        asNavFor: '.project__overview-theme2-slider-for',
        dots: false,
        arrows: false,
        centerMode: false,
        vertical: true,
        verticalSwiping: true,
        focusOnSelect: true,
        responsive: [
            {
            breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                }
            },
        ]
    });
    $(document ).ready(function() {
        var result = $(".project__overview-theme2-slider-for").height();
        $(".project__overview-theme2-slider-nav").css("height",  result);
    });

    $('.reference__slider').slick({
        dots: false,
        infinite: true,
        speed: 1500,
        slidesToShow: 4,
        autoplay: true,
        autoplaySpeed: 3000,
        swipeToSlide: true,
        variableWidth: true
    });

    $('.match-height').matchHeight();
    $('.agenda__inner').matchHeight();
    $('.agenda__title').matchHeight();
    $('.agenda__text').matchHeight();
    $('.login__logo').matchHeight();

    $('.content__image--right').each(function() {
        var imgSrc = $(this).attr('src');
        $(this).parent().css({'background-image': 'url('+imgSrc+')'});
        $(this).remove();
    });

    $('.footer--fixed').each(function() {
        footerHeight = $("footer").height();
        $(".footer--fixed .main").css({'margin-bottom': footerHeight});
    });

    $("a").each(function(i) {
        $(this).attr('id', ("go-a-" + (i+1)));
    });

    $(".search__container__btn").click(function () {
        $(".search__container").toggleClass("search__container--open");
        $(".search__container input").focus();
    });

    $("button").each(function(i) {
        $(this).attr('id', ("go-button-" + (i+1)));
    });

    $('.timeline-item:even').addClass("").viewportChecker({
        classToAdd: 'timeline-animation animated bounceInLeft',
        offset: 240
    });
    $('.timeline-item:odd').addClass("").viewportChecker({
        classToAdd: 'timeline-animation animated bounceInRight',
        offset: 240
    });

    $(".faq__item__btn").click(function () {
        $(this).parent().find('.faq__item__answer').toggleClass("faq__item__answer--open");
        $(this).toggleClass("faq__item__btn--open");
    });

    $('.downloads__categories > li .downloads__name').click(function() {
        let $this =  $(this);
        $('.downloads__categories > li .downloads__items').hide();
        $this.closest('li').find('.downloads__items').fadeIn();
        return false;
    });


    // $('.profiel__list li').on('click', function(){
    //     var check = $(this).find('.edit__checkbox input');
    //     if(check.is(':checked')){
    //         check.prop('checked', false);
    //     } else {
    //         check.prop('checked', true);
    //     }
    // });
    // $('.profiel__list li a').on('click', function(){
    //     var check = $(this).parent().find('.edit__checkbox input');
    //     if(check.is(':checked')){
    //         check.prop('checked', false);
    //     } else {
    //         check.prop('checked', true);
    //     }
    // });



    function Utils() {

    }

    Utils.prototype = {
        constructor: Utils,
        isElementInView: function (element, fullyInView) {
            var pageTop = $(window).scrollTop();
            var pageBottom = pageTop + $(window).height();
            var elementTop = $(element).offset().top;
            var elementBottom = elementTop + $(element).height();

            if (fullyInView === true) {
                return ((pageTop < elementTop) && (pageBottom > elementBottom));
            } else {
                return ((elementTop <= pageBottom) && (elementBottom >= pageTop));
            }
        }
    };

    var Utils = new Utils();


    if ($('span').hasClass("profiel__list__top")) {

        $(window).scroll(function () {
            var isElementInView = Utils.isElementInView($('.profiel__list__top'), false);

            if (isElementInView) {
                $('body').addClass('body-btn-vink__fixed');
            } else {
                $('body').removeClass('body-btn-vink__fixed');
            }
        });

    }




    $('*[data-stick]').each(function() {
        var $this = $(this),
            margin = $this.data('stick');

        $this.parent().theiaStickySidebar({
            additionalMarginTop: margin
        });
    });

    $(document).ready(function() {
        $('.content, .sidebar').theiaStickySidebar({
          // Settings
          additionalMarginTop: 30
        });
    });

    $('.sidebar__month a[href*="#"]:not([href="#"])').on('click',function(e) {
    	e.preventDefault();
    	var offset = 20;
    	var target = this.hash;
    	if ($(this).data('offset') != undefined) offset = $(this).data('offset');
    	$('html, body').stop().animate({
    		'scrollTop': $(target).offset().top - offset
    	}, 800, 'swing', function() {

    	});
    });

    $(".fdatepicker").fdatepicker({
        language: 'nl',
        format: 'dd-mm-yyyy',
        startView: 'year',
        initialDate: Date.now(),
    });


    $(".time").fdatepicker({
        format: 'hh:ii',
        disableDblClickSelection: true,
        pickTime: true,
        startView: 'day',
        maxView: 'day',
    });


    $(".disable-scroll").click(function () {
        $('.disable-scroll').fadeOut();
    });

    $(".language__selector__current").click(function () {
        $('.language__selector__all').fadeToggle();
    });

    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        if (scroll > 70) {
            $(".header__top").addClass("header-fix");
        }
        else {
            $(".header__top").removeClass("header-fix");
        }
    });

    // hide #back-top first
    $("#back-totop").hide();

    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            $('#back-totop').fadeIn();
        } else {
            $('#back-totop').fadeOut();
        }
    });

    // scroll body to 0px on click
    $('#back-totop').click(function () {
        $('body,html').animate({scrollTop: 0}, 800);
        return false;
    });

    if (window.matchMedia('(min-width: 1024px)').matches) {
        var e = document.getElementsByClassName("phone");
        for (i = 0; i < e.length; i++)
        e[i].setAttribute("x-ms-format-detection", "none");
    }


    ajaxFilter();

    // popup warning
    $(".warning__close").click(function () {
        $(".warning").css("display","none");
    });

    $(".cms__btn__close").click(function () {
        $(".cms__btn__close").toggleClass("cms__btn--open");
        $(".cms__edit").toggleClass("cms__edit--close");
    });
});

function ajaxFilter()
{
    $('.ajax-filter').each(function(){
        var form = $(this);
        form.append('<input type="hidden" name="action" value="Filter" />');
        form.append('<input type="hidden" name="koppel" value="' + form.attr('data-koppel') + '" />');
        $(this).find(':input[type="checkbox"]').change(function(){
            $.fancybox.showLoading();
            $.ajax({
                url: window.location.href,
                data: form.serialize(),
                type: 'post',
                success: function(data)
                {
                    $('.ajax-filter').replaceWith(data);
                    new Foundation.Accordion($('.accordion'));
                    $.fancybox.hideLoading();
                    ajaxFilter();
                }
            });
        })
    });
}

/*
Reference: http://jsfiddle.net/BB3JK/47/
*/

$('.projects__filter select').each(function(){
    var $this = $(this), numberOfOptions = $(this).children('option').length;

    $this.addClass('select-hidden');
    $this.wrap('<div class="select"></div>');
    $this.after('<div class="select-styled"></div>');

    var $styledSelect = $this.next('div.select-styled');
    $styledSelect.text($this.children('option').eq(0).text());

    var $list = $('<ul />', {
        'class': 'select-options'
    }).insertAfter($styledSelect);

    for (var i = 0; i < numberOfOptions; i++) {
        $('<li />', {
            text: $this.children('option').eq(i).text(),
            rel: $this.children('option').eq(i).val()
        }).appendTo($list);
    }

    var $listItems = $list.children('li');

    $styledSelect.click(function(e) {
        e.stopPropagation();
        $('div.select-styled.active').not(this).each(function(){
            $(this).removeClass('active').next('ul.select-options').hide();
        });
        $(this).toggleClass('active').next('ul.select-options').toggle();
    });

    $listItems.click(function(e) {
        e.stopPropagation();
        $styledSelect.text($(this).text()).removeClass('active');
        $this.val($(this).attr('rel'));
        $list.hide();
        //console.log($this.val());
    });

    $(document).click(function() {
        $styledSelect.removeClass('active');
        $list.hide();
    });

});

$('.btn--cat').click(function(){
    $('body').addClass('projects__cat__open');
    $('.projects__cat__shadow').fadeToggle(300);
});

$('.projects__cat__hide').click(function(){
    $('body').removeClass('projects__cat__open');
    $('.projects__cat__shadow').fadeToggle(300);
});

$('.projects__cat__block__title').click(function(){
    $(this).parent().toggleClass('projects__cat__block__open');
    $(this).next('ul').slideToggle(300);
});

$('.projects__cat__shadow').click(function(){
    $(this).fadeToggle(300);
    $('body').removeClass('projects__cat__open');
});

$('.btn--filter').click(function(){
    $('.projects__cat__block input').prop( "checked", false );
});

$('[data-fancybox="video"]').fancybox({
  afterLoad : function( instance, current ) {

     // Remove scrollbars and change background
    current.$content.css({
    	overflow   : 'visible',
        background : '#000'
	});

  },
  onUpdate : function( instance, current ) {
    var width,
        height,
        ratio = 16 / 9,
        video = current.$content;

    if ( video ) {
      video.hide();

      width  = current.$slide.width();
      height = current.$slide.height() - 100;

      if ( height * ratio > width ) {
        height = width / ratio;
      } else {
        width = height * ratio;
      }

      video.css({
        width  : width,
        height : height
      }).show();

    }
  }
});


(function($) {
    var baseTpl	= '<div class="fancybox__ajax__overlay">' +
        '<div class="fancybox__loading__icon">' +
        '<i class="fas fa-spinner fa-pulse"></i>' +
        '</div>' +
        '</div>';

    var extensionMethods = {
        showLoading: function () {
            $('body').append(baseTpl);
        },
        hideLoading: function () {
            $('html').find('.fancybox__loading__icon').closest('.fancybox__ajax__overlay').remove();
        }
    };

    $.extend(true, $.fancybox, extensionMethods);
})(jQuery);


// Step 1: Create reusable jQuery plugin
// =====================================

$.fancyConfirm = function( opts ) {
    opts  = $.extend( true, {
        title     : 'Are you sure?',
        message   : '',
        okButton  : 'OK',
        noButton  : 'Cancel',
        callback  : $.noop
    }, opts || {} );

    $.fancybox.open({
        type : 'html',
        src  :
            '<div class="fc-content">' +
            '<h3>' + opts.title   + '</h3>' +
            '<p>'  + opts.message + '</p>' +
            '<p class="tright">' +
            '<a data-value="0" data-fancybox-close class="btn btn--selection-download">' + opts.noButton + '</a>' +
            '<button data-value="1" data-fancybox-close class="btn" style="float:right;">' + opts.okButton + '</button>' +
            '</p>' +
            '</div>',
        opts : {
            animationDuration : 350,
            animationEffect   : 'material',
            modal : true,
            baseTpl :
                '<div class="fancybox-container fc-container" role="dialog" tabindex="-1">' +
                '<div class="fancybox-bg"></div>' +
                '<div class="fancybox-inner">' +
                '<div class="fancybox-stage"></div>' +
                '</div>' +
                '</div>',
            afterClose : function( instance, current, e ) {
                var button = e ? e.target || e.currentTarget : null;
                var value  = button ? $(button).data('value') : 0;

                opts.callback( value );
            }
        }
    });
};
